// Microsoft sign-in and sign-out (server/auth/saml/README.md). Both are full-page navigations through Microsoft.

const REDIRECT_KEY = 'ssoRedirectAt';
// A silent re-sign-in happens at most once per minute, so a broken sign-in can never loop.
const REDIRECT_GUARD_MS = 60 * 1000;

let redirecting = false;
// true once this page is on its way to Microsoft (nested ProtectedRoutes then keep waiting instead of rendering)
export const isRedirecting = () => redirecting;

const safePath = (value) => (typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/login') ? value : '');

export const signInUrl = (returnTo) => {
  const path = safePath(returnTo);
  return `/api/saml/login${path ? `?returnTo=${encodeURIComponent(path)}` : ''}`;
};

export const storedReturnPath = () => {
  try {
    return safePath(localStorage.getItem('prevLocation'));
  } catch {
    return '';
  }
};

// Re-confirm with Microsoft without the login page (no password when the Microsoft session is still valid).
// Returns false when it just happened, so the caller falls back to the login page instead.
export function startSilentSignIn(returnTo) {
  try {
    if (Date.now() - (Number(sessionStorage.getItem(REDIRECT_KEY)) || 0) < REDIRECT_GUARD_MS) return false;
    sessionStorage.setItem(REDIRECT_KEY, String(Date.now()));
  } catch {
    return false;
  }
  redirecting = true;
  window.location.assign(signInUrl(returnTo));
  return true;
}

// Ends the session here and at Microsoft; Microsoft sends the browser back to /login?signedOut=1.
export function signOut() {
  try {
    localStorage.clear();
    sessionStorage.removeItem(REDIRECT_KEY);
  } catch {
    // storage blocked: the server-side sign-out below still happens
  }
  redirecting = true;
  window.location.assign('/api/saml/logout');
}
